var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"drag",staticClass:"vp__left__drawer",style:(_vm.openLeft ? ("left:calc(" + _vm.leftPanelWidth + " + 90px)") : "display: none")})}
var staticRenderFns = []

export { render, staticRenderFns }